export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
export const REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION";
export const SHOW_ALL = "SHOW_ALL";
